module.exports = __webpack_public_path__ + "img/Seed_footer_img.346f2e23.png";